import axios from 'axios';
import { projectApi as api } from './api';
import { Project } from 'types/store/projectsList';
import { JsonApiResponse } from 'types/store/jsonApi';

interface FetchProjectsListParams {
  url: string;
  includeTotalCount?: boolean;
}

export const fetchProjectsList: (
  params: FetchProjectsListParams
) => Promise<JsonApiResponse<Project>> = async ({ url, includeTotalCount }) => {
  const config = {
    headers: {
      'include-total-count': includeTotalCount ? 'true' : 'false',
    },
  };

  const response = await api.get<JsonApiResponse<Project>>(url, config);

  if (axios.isAxiosError(response)) {
    throw response;
  }

  return response.data;
};

export interface BulkUpdateProjectsParams {
  ids: string[];
  status: string;
  holdReason?: string;
  cancelReason?: string;
  cancellationDate?: string;
  closedDate?: string;
  actualCompletionDate?: string;
  finalComments?: string;
  isArchived?: boolean;
}

export interface BulkUpdateProjectsResponse {
  attemptedCount: number;
  successfulCount: number;
  failedCount: number;
}

export const bulkUpdateProjects = async (params: BulkUpdateProjectsParams) => {
  const {
    ids,
    status,
    holdReason,
    cancelReason,
    cancellationDate,
    closedDate,
    actualCompletionDate,
    finalComments,
    isArchived,
  } = params;

  const payload: any = {
    data: {
      type: 'projects',
      attributes: {
        ids,
        status,
      },
    },
  };

  if (holdReason) {
    payload.data.attributes.holdReason = holdReason;
  }
  if (cancelReason) {
    payload.data.attributes.cancelReason = cancelReason;
  }
  if (cancellationDate) {
    payload.data.attributes.cancellationDate = cancellationDate;
  }
  if (closedDate) {
    payload.data.attributes.closedDate = closedDate;
  }
  if (actualCompletionDate) {
    payload.data.attributes.actualCompletionDate = actualCompletionDate;
  }
  if (finalComments) {
    payload.data.attributes.finalComments = finalComments;
  }
  if (isArchived !== undefined) {
    payload.data.attributes.isArchived = isArchived;
  }

  const response = await api.patch<JsonApiResponse<BulkUpdateProjectsResponse>>(
    '/projects',
    payload
  );

  if (axios.isAxiosError(response)) {
    throw response;
  }

  return response.data;
};
